import { OrderByDatePipe, SliceArrayPipe } from '@my-account/utils/pipes';

import { BatfittingComponent } from './batfitting.component';
import { BatfittingSessionItemModule } from './batfitting-session-item/batfitting-session-item.module';
import { CommonModule } from '@angular/common';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [BatfittingComponent, OrderByDatePipe, SliceArrayPipe],
	imports: [
		BatfittingSessionItemModule,
		CommonModule,
		HmfButtonComponent
	],
	exports: [BatfittingComponent]
})
export class BatfittingModule {}
